import styled from 'styled-components'

export const PhoneImage = styled.img`
  width: 100%;
  height: auto;
`

export const PhoneWrapper = styled.div`
  width: 100%;
  height: auto;
  max-width: 400px;
  display: block;
  position: relative;
  z-index: 10;
  margin-bottom: 32px;
`
